module.exports = __webpack_public_path__ + "img/fleet-about-bgstrip.jpg";